module.exports = __webpack_public_path__ + "static/media/paddleball.929a9e54.jpg";